import ApiService from 'services/ApiService';

import { MESSAGES, SUBSCRIPTION_TYPE } from 'constants/Constants';
import { AppActions } from 'store/appModule/actions';
import { addNotification } from 'store/notificationModule/actions';
import { actionTypeCreator } from 'utils/actionUtils';
import { extractError } from 'utils/functions';
import { CONVERSION_TYPES, EVENT_LEVEL, EVENT_TYPES } from '../../../../../../components/Upsell/Constants';

const ACTION_PREFIX = 'seats';

export const SubscriptionActionTypes = {
  CHANGE_SUBSCRIPTION: `${ACTION_PREFIX}/CHANGE_SUBSCRIPTION`,
  CREATE_AND_ASSIGN_SUBSCRIPTION: `${ACTION_PREFIX}/CREATE_AND_ASSIGN_SUBSCRIPTION`,
  ON_USERS_PAGE_CHANGE: `${ACTION_PREFIX}/ON_SUBSCRIPTION_PAGE_CHANGE`,
  MODAL_SHOW: `${ACTION_PREFIX}/MODAL_SHOW`,
  MODAL_HIDE: `${ACTION_PREFIX}/MODAL_HIDE`,
  TRIGGER_ASSIGN_MODAL: `${ACTION_PREFIX}/TRIGGER_ASSIGN_MODAL`,
  SET_SUBSCRIPTION_FILTER: `${ACTION_PREFIX}/SET_SUBSCRIPTION_FILTER`,
  SET_USERS_FILTER: `${ACTION_PREFIX}/SET_USERS_FILTER`,

  ...actionTypeCreator(ACTION_PREFIX, 'CANCEL_SUBSCRIPTION'),
  ...actionTypeCreator(ACTION_PREFIX, 'ASSIGN_SUBSCRIPTION'),
  ...actionTypeCreator(ACTION_PREFIX, 'UPGRADE_SUBSCRIPTION'),
  ...actionTypeCreator(ACTION_PREFIX, 'DOWNGRADE_SUBSCRIPTION'),
  ...actionTypeCreator(ACTION_PREFIX, 'FETCH_SUBSCRIPTIONS'),
  ...actionTypeCreator(ACTION_PREFIX, 'NEW_SUBSCRIPTION'),
  ...actionTypeCreator(ACTION_PREFIX, 'RENEWAL_SUBSCRIPTION'),
  ...actionTypeCreator(ACTION_PREFIX, 'UPDATE_AUTO_RENEWAL_PLAN'),
};

export function onPageChange(page) {
  return dispatch => {
    dispatch({
      type: SubscriptionActionTypes.ON_USERS_PAGE_CHANGE,
      payload: {
        page,
      },
    });
  };
}

export function showModal(modal, selectedUser = null) {
  return {
    type: SubscriptionActionTypes.MODAL_SHOW,
    payload: {
      modal,
      selectedUser,
    },
  };
}

export function hideModal() {
  return {
    type: SubscriptionActionTypes.MODAL_HIDE,
  };
}

export function triggerAssignModal(subscription) {
  return {
    type: SubscriptionActionTypes.TRIGGER_ASSIGN_MODAL,
    payload: {
      ...subscription,
    },
  };
}

export function renewalInProgress() {
  return {
    type: SubscriptionActionTypes.RENEWAL_SUBSCRIPTION_WAITING,
    payload: {
      status: MESSAGES.RENEWAL_PROGRESS_MSG,
    },
  };
}

export function renewalSubscription(subscriptionId) {
  return {
    type: SubscriptionActionTypes.RENEWAL_SUBSCRIPTION_LOAD,
    payload: subscriptionId,
  };
}

export function renewalFailure(msgError) {
  return {
    type: SubscriptionActionTypes.RENEWAL_SUBSCRIPTION_FAILED,
    payload: {
      status: msgError || MESSAGES.RENEWAL_FAILURE_GENERAL_ERROR,
    },
  };
}

export function renewalCompleted(subscriptions) {
  return {
    type: SubscriptionActionTypes.RENEWAL_SUBSCRIPTION_COMPLETED,
    payload: {
      subscriptions,
    },
  };
}

export function reassignSubscription(subscriptionId, userId) {
  return {
    type: SubscriptionActionTypes.ASSIGN_SUBSCRIPTION_LOAD,
    payload: {
      subscriptionId,
      userId,
    },
  };
}

export function reassignInProgress() {
  return {
    type: SubscriptionActionTypes.ASSIGN_SUBSCRIPTION_WAITING,
    payload: {
      status: MESSAGES.REASSIGN_PROGRESS_MSG,
    },
  };
}

export function reassignFailure(msgError) {
  return {
    type: SubscriptionActionTypes.ASSIGN_SUBSCRIPTION_FAILED,
    payload: {
      status: msgError || MESSAGES.REASSIGN_FAILURE_GENERAL_ERROR,
    },
  };
}

export function reassignCompleted(res) {
  return {
    type: SubscriptionActionTypes.ASSIGN_SUBSCRIPTION_COMPLETED,
    payload: {
      subscription: res.subscription ? res.subscription : res,
    },
  };
}

export function createAndAssignSubscription(subscriptionId, email, password, firstName, lastName) {
  return {
    type: SubscriptionActionTypes.CREATE_AND_ASSIGN_SUBSCRIPTION,
    payload: {
      subscriptionId,
      email,
      password,
      firstName,
      lastName,
    },
  };
}

export function cancelInProgress() {
  return {
    type: SubscriptionActionTypes.CANCEL_SUBSCRIPTION_WAITING,
    payload: {
      status: MESSAGES.CANCEL_PROGRESS_MSG,
    },
  };
}

export function cancelFailure(msgError) {
  return {
    type: SubscriptionActionTypes.CANCEL_SUBSCRIPTION_FAILED,
    payload: {
      status: msgError || MESSAGES.CANCEL_FAILURE_GENERAL_ERROR,
    },
  };
}

export function cancelCompleted() {
  return {
    type: SubscriptionActionTypes.CANCEL_SUBSCRIPTION_COMPLETED,
    payload: {},
  };
}

export function changeSubscription(subscriptionId, newSubscriptionType, billingPeriod, isDowngrade) {
  return {
    type: SubscriptionActionTypes.CHANGE_SUBSCRIPTION,
    payload: {
      subscriptionId,
      newSubscriptionType,
      billingPeriod,
      isDowngrade,
    },
  };
}

export function upgradeInProgress() {
  return {
    type: SubscriptionActionTypes.UPGRADE_SUBSCRIPTION_WAITING,
    payload: {
      status: MESSAGES.UPGRADE_PROGRESS_MSG,
    },
  };
}

export function upgradeFailure(msgError) {
  return {
    type: SubscriptionActionTypes.UPGRADE_SUBSCRIPTION_FAILED,
    payload: {
      status: msgError || MESSAGES.UPGRADE_FAILURE_GENERAL_ERROR,
    },
  };
}

export function upgradeCompleted(subscriptions) {
  return {
    type: SubscriptionActionTypes.UPGRADE_SUBSCRIPTION_COMPLETED,
    payload: {
      subscriptions,
    },
  };
}

export function downgradeInProgress() {
  return {
    type: SubscriptionActionTypes.DOWNGRADE_SUBSCRIPTION_WAITING,
    payload: {
      status: MESSAGES.DOWNGRADE_PROGRESS_MSG,
    },
  };
}

export function downgradeFailure(msgError) {
  return {
    type: SubscriptionActionTypes.DOWNGRADE_SUBSCRIPTION_FAILED,
    payload: {
      status: msgError || MESSAGES.DOWNGRADE_FAILURE_GENERAL_ERROR,
    },
  };
}

export function downgradeCompleted(subscriptions) {
  return {
    type: SubscriptionActionTypes.DOWNGRADE_SUBSCRIPTION_COMPLETED,
    payload: {
      subscriptions,
    },
  };
}

export function createSubscription(subscriptionType, subscriptionRenewal, subscriptionQuantity) {
  return {
    type: SubscriptionActionTypes.NEW_SUBSCRIPTION_LOAD,
    payload: {
      subscriptionType,
      subscriptionRenewal,
      subscriptionQuantity,
    },
  };
}

export function createSubscriptionInProgress(subscriptionQuantity = 1) {
  return {
    type: SubscriptionActionTypes.NEW_SUBSCRIPTION_WAITING,
    payload: {
      status:
        subscriptionQuantity > 1 ? MESSAGES.NEW_SUBSCRIPTIONS_PROGRESS_MSG : MESSAGES.NEW_SUBSCRIPTION_PROGRESS_MSG,
    },
  };
}

export function createSubscriptionFailed(msgError) {
  return {
    type: SubscriptionActionTypes.NEW_SUBSCRIPTION_FAILED,
    payload: {
      status: msgError || MESSAGES.NEW_SUBSCRIPTION_FAILURE_GENERAL_ERROR,
    },
  };
}

export function createSubscriptionCompleted(subscriptions) {
  return {
    type: SubscriptionActionTypes.NEW_SUBSCRIPTION_COMPLETED,
    payload: {
      subscriptions,
    },
  };
}

export function fetchSubscriptions(page) {
  return {
    type: SubscriptionActionTypes.FETCH_SUBSCRIPTIONS_LOAD,
    payload: page,
  };
}

export function fetchSubscriptionInProgress() {
  return {
    type: SubscriptionActionTypes.FETCH_SUBSCRIPTIONS_WAITING,
  };
}

export function fetchSubscriptionFailed() {
  return {
    type: SubscriptionActionTypes.FETCH_SUBSCRIPTIONS_FAILED,
    payload: {
      status: MESSAGES.ERROR_FETCHING_SUBSCRIPTION,
    },
  };
}

export function fetchSubscriptionCompleted(subscriptions) {
  return {
    type: SubscriptionActionTypes.FETCH_SUBSCRIPTIONS_COMPLETED,
    payload: {
      subscriptions,
    },
  };
}

export function setUsersFilter(type, value) {
  return dispatch => {
    dispatch({
      type: SubscriptionActionTypes.SET_USERS_FILTER,
      payload: {
        type,
        value,
      },
    });
  };
}

export function updateAutoRenewalPlan(toRenew, updatedSeats, successMessage) {
  return {
    type: SubscriptionActionTypes.UPDATE_AUTO_RENEWAL_PLAN_LOAD,
    payload: { toRenew, updatedSeats, successMessage },
  };
}

export function updateAutoRenewalPlanInProgress() {
  return {
    type: SubscriptionActionTypes.UPDATE_AUTO_RENEWAL_PLAN_WAITING,
    payload: {
      status: MESSAGES.UPDATE_RENEWAL_PROGRESS_MSG,
    },
  };
}

export function updateAutoRenewalPlanFailure(msgError) {
  return {
    type: SubscriptionActionTypes.UPDATE_AUTO_RENEWAL_PLAN_FAILED,
    payload: {
      error: msgError,
    },
  };
}

export function updateAutoRenewalPlanCompleted(autoRenewalStatus, updatedSeats) {
  return {
    type: SubscriptionActionTypes.UPDATE_AUTO_RENEWAL_PLAN_COMPLETED,
    payload: { autoRenewalStatus, updatedSeats },
  };
}

export const SubscriptionActions = {
  onPageChange,
  showModal,
  hideModal,
  triggerAssignModal,
  renewalInProgress,
  renewalFailure,
  renewalCompleted,
  reassignInProgress,
  reassignFailure,
  reassignCompleted,
  cancelInProgress,
  cancelFailure,
  cancelCompleted,
  upgradeInProgress,
  upgradeFailure,
  upgradeCompleted,
  downgradeInProgress,
  downgradeFailure,
  downgradeCompleted,
  createSubscriptionInProgress,
  createSubscriptionFailed,
  createSubscriptionCompleted,
  fetchSubscriptionInProgress,
  fetchSubscriptionFailed,
  fetchSubscriptionCompleted,

  // Async
  onMultiAssignCompleted,

  createSubscriptionWithCreditCard,
  changeSubscriptionWithCreditCard,

  // Sagas Triggers
  reassignSubscription,
  createAndAssignSubscription,
  changeSubscription,
  createSubscription,
  fetchSubscriptions,
  renewalSubscription,

  // Seats
  setUsersFilter,
  updateAutoRenewalPlan,
  updateAutoRenewalPlanInProgress,
  updateAutoRenewalPlanCompleted,
  updateAutoRenewalPlanFailure,
};

/**
|--------------------------------------------------
| Async Actions
|--------------------------------------------------
*/

export function createSubscriptionWithCreditCard(
  token,
  card,
  subscriptionType,
  subscriptionRenewal,
  subscriptionQuantity,
) {
  return dispatch => {
    dispatch(AppActions.createPaymentInProgress());
    ApiService.createCreditCardWithSubscription({
      token,
      card,
      type: subscriptionType,
      period: subscriptionRenewal,
      quantity: subscriptionQuantity,
    }).then(
      res => {
        dispatch(addNotification(MESSAGES.CREATE_PAYMENT_SUCCESS));
        dispatch(AppActions.createPaymentCompleted(res.data.payment_method));
        dispatch(createSubscriptionCompleted(res.data.subscriptions));
        ApiService.track({
          uuid: null,
          action: null,
          event: EVENT_TYPES.CONVERSION,
          level: EVENT_LEVEL.SUCCESS,
          name: CONVERSION_TYPES.PURCHASE,
        });
        if (subscriptionQuantity > 1) {
          dispatch(addNotification(MESSAGES.NEW_SUBSCRIPTIONS_COMPLETED_SUCCESS, 'success'));
          return dispatch(showModal('multiAssignSubscriptions'));
        }
        dispatch(addNotification(MESSAGES.NEW_SUBSCRIPTION_COMPLETED_SUCCESS, 'success'));
        if (!res.data.subscriptions[0].username) {
          return dispatch(triggerAssignModal(res.data.subscriptions[0]));
        }
        return undefined;
      },
      error => {
        if (error.data && error.data.payment_method) {
          dispatch(AppActions.createPaymentCompleted(error.data.payment_method));
          dispatch(createSubscriptionFailed());
        } else {
          dispatch(AppActions.createPaymentFailed(extractError(error.data)));
        }
      },
    );
  };
}

export function changeSubscriptionWithCreditCard(
  name,
  address,
  city,
  country,
  state,
  postalCode,
  number,
  cvv,
  month,
  year,
  subscriptionType,
  subscriptionRenewal,
  subscriptionId,
) {
  return (dispatch, getState) => {
    dispatch(
      AppActions.createCreditCard(name, address, city, country, state, postalCode, number, cvv, month, year),
    ).then(() => {
      if (getState().app.paymentMethod.is_chargeable) {
        dispatch(changeSubscription(subscriptionId, SUBSCRIPTION_TYPE, subscriptionRenewal));
      }
    });
  };
}

export function onMultiAssignCompleted() {
  return dispatch => {
    dispatch(hideModal());
    dispatch(fetchSubscriptions());
    dispatch(AppActions.fetchOrganizationMembers());
  };
}
